import React, { useState, useEffect, useRef  } from "react";
import axios from "axios";
import "../css/LocationMRvsMGR.css"; 
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "./CustomButton";
const LocationMRvsMGR = () => {
// State for dropdown options
const [states, setStates] = useState([]);
const [managers, setManagers] = useState([]);
const [members, setMembers] = useState([]);
const [selectedManager, setSelectedManager] = useState("");
const [selectedMember, setSelectedMember] = useState("");
// const [emp1Data, setEmp1Data] = useState(null);
// const [emp2Data, setEmp2Data] = useState(null);
const [comparisonData, setComparisonData] = useState(null);
const [heading, setHeading] = useState("");

// State for selected filters
const [selectedState, setSelectedState] = useState("");

// State for validation
const [validationErrors, setValidationErrors] = useState({
  state: false,
  division: false,
  employee: false
});

// State for table data and UI
const [showTable, setShowTable] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [error, setError] = useState(null);
const tableRef = useRef();

// Month/Year dropdown setup
const getMonthYearOptions = () => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const currentYear = new Date().getFullYear();
  return months.map((month, index) => ({
    label: `${month} ${currentYear}`,
    value: `${String(index + 1).padStart(2, '0')}-${currentYear}`
  }));
};

const monthYearOptions = getMonthYearOptions();
const [pobMonthYear, setPobMonthYear] = useState(monthYearOptions[new Date().getMonth()].value);

// Fetch states on mount
useEffect(() => {
  console.log("Fetching states...");
  // axios.get(`${BASE_URL}/api/states`,{headers:getAuthHeaders()})
  //   .then(res => {
  //     console.log("States API response:", res.data);
  //     setStates(res.data);
  //   })
  //   .catch(err => {
  //     console.error("Error fetching states:", err);
  //     console.error("Error details:", err.response?.data || err.message);
  //   });
  axios.get(`${BASE_URL}/api/states`, { headers: getAuthHeaders() })
  .then(res => {
    console.log("States API response:", res.data);

    // If API returns an object with "states" key
    if (Array.isArray(res.data)) {
      setStates(res.data);   // already array
    } else if (Array.isArray(res.data.states)) {
      setStates(res.data.states);  // pick nested array
    } else {
      setStates([]);  // fallback to empty array
    }
  })
  .catch(err => {
    console.error("Error fetching states:", err);
    setStates([]); // fallback in case of error
  });

}, []);

const handleStateChange = async (stateId) => {
  console.log("State changed to:", stateId);
  setSelectedState(stateId);
  setSelectedManager("");
  setSelectedMember("");
  setManagers([]);
  setMembers([]);
  
  try {
    console.log("Fetching managers for state:", stateId);
    const response = await axios.get(`${BASE_URL}/api/managers/${stateId}`,{headers:getAuthHeaders()});
    console.log("Managers API response:", response.data);
    setManagers(response.data);
  } catch (err) {
    console.error("Error fetching managers:", err);
    console.error("Error details:", err.response?.data || err.message);
  }
};

const handleManagerChange = async (managerId) => {
  console.log("Manager changed to:", managerId);
  setSelectedManager(managerId);
  setSelectedMember("");

  try {
    console.log(`Fetching members for state ${selectedState} and manager ${managerId}`);
    const response = await axios.get(`${BASE_URL}/api/members/${selectedState}/${managerId}`,{headers:getAuthHeaders()});
    console.log("Members API response:", response.data);
    setMembers(response.data);
  } catch (err) {
    console.error("Error fetching members:", err);
    console.error("Error details:", err.response?.data || err.message);
    setError("Failed to load members.");
  }
};

const validateForm = () => {
  const errors = {
    state: !selectedState,
    manager: !selectedManager,
    member: !selectedMember
  };
  console.log("Form validation errors:", errors);
  setValidationErrors(errors);
  return !errors.state && !errors.manager && !errors.member;
};

const handleGoClick = async () => {
  console.log("GO button clicked with state:", {
    selectedState,
    selectedManager,
    selectedMember,
    pobMonthYear
  });

  if (!validateForm()) {
    console.log("Validation failed - not proceeding with API call");
    return;
  }

  try {
    setIsLoading(true);
    setError(null);

    // Extract month and year from pobMonthYear (format "MM-YYYY")
    const [month, year] = pobMonthYear.split('-').map(Number);
    console.log("Month/Year extracted:", { month, year });

    // Fetch comparison data
    const apiUrl = `${BASE_URL}/api/dcr-comparison/${selectedManager}/${selectedMember}/${month}/${year}`;
    console.log("Making API call to:", apiUrl);
    
    const response = await axios.get(apiUrl, { headers: getAuthHeaders() });
    console.log("Comparison API response:", response.data);
    
    // Generate heading locally since API now returns just table_data
    const manager = managers.find(m => String(m.employee_id) === String(selectedManager));
    const member = members.find(m => String(m.employee_id) === String(selectedMember));
    
    if (!manager || !member) {
      console.error("Manager or member not found in local state");
      throw new Error("Employee data not found");
    }
    
    const heading = `Compare DCR - ${manager.employee_name} (${manager.employee_designation}|${manager.headquarter_name}|${manager.employee_division}|${manager.state_name}) Vs ${member.employee_name} (${member.employee_designation}|${member.employee_division}|${member.headquarter_name}|${member.state_name}) (${new Date(year, month-1).toLocaleString('default', { month: 'short' })} ${year})`;
    
    console.log("Generated heading:", heading);
    setHeading(heading);
    setComparisonData(response.data);
    setShowTable(true);
  } catch (err) {
    console.error("Failed to fetch comparison data", err);
    console.error("Error details:", err.response?.data || err.message);
    setError("Failed to load comparison data. Please try again.");
  } finally {
    setIsLoading(false);
  }
};

// Add this effect to update data when month/year changes
useEffect(() => {
  if (selectedManager && selectedMember && showTable) {
    console.log("Month/Year changed - refreshing data");
    handleGoClick();
  }
}, [pobMonthYear]);

    const handlePrint = () => {
        const printContent = tableRef.current.innerHTML;
    
        const printWindow = window.open("", "_blank", "width=900,height=600");
        if (printWindow) {
        printWindow.document.write(`
            <html>
            <head>
                <title>Print Table</title>
                <style>
                body {
                    font-family: Arial, sans-serif;
                    padding: 20px;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                }
                th, td {
                    border: 1px solid #ccc;
                    padding: 8px;
                    text-align: left;
                }
                th {
                    background-color: #f2f2f2;
                }
                </style>
            </head>
            <body>
                <h2>Stockist Data</h2>
                ${printContent}
                <script>
                window.onload = function() {
                    window.print();
                }
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
        }
    };
    
    const handleExport = () => {
        const XLSX = require("xlsx");
    
        const ws = XLSX.utils.table_to_sheet(tableRef.current.querySelector("table"));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "StockistData");
    
        XLSX.writeFile(wb, "stockist_data.xlsx");
    };
  
    // Add this table rendering function
    const renderComparisonTable = () => {
      if (!comparisonData || !comparisonData.length) return <div>No data available</div>;
    
      return (
        <div className="comparison-table-container" ref={tableRef}>
          <table className="comparison-table">
            <thead className="text-white">
              <tr>
                <th rowSpan="2">S.No</th>
                <th rowSpan="2">Working Day</th>
                <th colSpan="7">{managers.find(m => m.employee_id === selectedManager)?.employee_name || 'Manager'}</th>
                <th colSpan="7">{members.find(m => m.employee_id === selectedMember)?.employee_name || 'Member'}</th>
                <th rowSpan="2">Location Match</th>
              </tr>
              <tr>
                {/* Manager headers */}
                <th>Fill Date</th>
                <th>L/H</th>
                <th>Doc Met</th>
                <th>Che Met</th>
                <th>Sto Met</th>
                <th>Working With</th>
                <th>GPS</th>
                
                {/* Member headers */}
                <th>Fill Date</th>
                <th>L/H</th>
                <th>Doc Met</th>
                <th>Che Met</th>
                <th>Sto Met</th>
                <th>Working With</th>
                <th>GPS</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => {
                const date = new Date(row.working_day);
                const isSunday = date.getDay() === 0;
                
                return (
                  <tr key={index} className={isSunday ? 'sunday-row' : ''}>
                    <td>{row.s_no}</td>
                    <td>{row.working_day}</td>
                    
                    {/* Manager data */}
                    <td>{row.emp1.fill_date || '-'}</td>
                    <td>{row.emp1.leave_status || '-'}</td>
                    <td>{row.emp1.doc_met || '0'}</td>
                    <td>{row.emp1.che_met || '0'}</td>
                    <td>{row.emp1.sto_met || '0'}</td>
                    <td>{row.emp1.working_with || '-'}</td>
                    <td>{row.emp1.gps || 'No'}</td>
                    
                    {/* Member data */}
                    <td>{row.emp2.fill_date || '-'}</td>
                    <td>{row.emp2.leave_status || '-'}</td>
                    <td>{row.emp2.doc_met || '0'}</td>
                    <td>{row.emp2.che_met || '0'}</td>
                    <td>{row.emp2.sto_met || '0'}</td>
                    <td>{row.emp2.working_with || '-'}</td>
                    <td>{row.emp2.gps || 'No'}</td>
                    
                    <td>{row.location_match || 'No'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
  };
  

  return (
    <div className="LocationMRvsMGR-main">
      <div className="LocationMRvsMGR-filter-container">
       
<h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4"><span class="text-blue-700"> Select </span><span class="text-blue-500">Filter</span></h1>
        <div className="LocationMRvsMGR-filter-row1">
          <label className="LocationMRvsMGR-label">State:</label>
          <select
            className={`LocationMRvsMGR-dropdown ${validationErrors.state ? 'error' : ''}`}
            value={selectedState}
            onChange={(e) => handleStateChange(e.target.value)}
            disabled={isLoading}
          >
            <option value="">Select State</option>
            {/* {states.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))} */}
            {Array.isArray(states) && states.map((state) => (
  <option key={state.id} value={state.id}>
    {state.name}
  </option>
))}

          </select>
          {validationErrors.state && <span className="required-text">* Required</span>}

          
          <label className="LocationMRvsMGR-label">Month / Year:</label>
          <select
            className="LocationMRvsMGR-dropdown"
            value={pobMonthYear}
            onChange={(e) => setPobMonthYear(e.target.value)}
            // disabled={isLoading}
          >
            {monthYearOptions.map((option, idx) => (
              <option key={idx} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {validationErrors.division && <span className="required-text">* Required</span>}
        </div>

        <div className="LocationMRvsMGR-filter-row2">
          <label className="LocationMRvsMGR-label">Manager:</label>
          <select
            className={`LocationMRvsMGR-dropdown ${validationErrors.managers ? 'error' : ''}`}
            value={selectedManager}
            onChange={(e) => {
                handleManagerChange(e.target.value);
                setValidationErrors({...validationErrors, managers: false});
              }}
              required
            // disabled={!selectedState || isLoading}
          >
            <option value="">Select Manager</option>
            {managers.map((emp) => (
               <option key={emp.employee_id} value={emp.employee_id}>
               {`${emp.employee_name} | ${emp.employee_designation} | ${emp.headquarter_name} | ${emp.employee_division} | ${emp.state_name}`}
             </option>
            ))}
          </select>
          <label className="LocationMRvsMGR-label">Member:</label>
          <select
            className={`LocationMRvsMGR-dropdown ${validationErrors.members ? 'error' : ''}`}
            value={selectedMember}
            onChange={(e) => {
                setSelectedMember(e.target.value);
                setValidationErrors({...validationErrors, members: false});
              }}
              required
            // disabled={!selectedState || isLoading}
          >
            <option value="">Select Member</option>
            {members.map((emp) => (
               <option key={emp.employee_id} value={emp.employee_id}>
               {`${emp.employee_name} | ${emp.employee_designation} | ${emp.headquarter_name} | ${emp.employee_division} | ${emp.state_name}`}
             </option>
            ))}
          </select>
          {validationErrors.members && <span className="required-text">* Required</span>}

        </div>

        <button 
          className="LocationMRvsMGR-go-button" 
          onClick={handleGoClick}
          disabled={isLoading || !selectedState}
        >
          {isLoading ? "Loading..." : "GO"}
        </button>

        {error && <div className="LocationMRvsMGR-error">{error}</div>}
      </div>
      {showTable && (
                <>
                    {/* Table container */}
                    <div className="LocationMRvsMGR-table-container">
                    <div className="LocationMRvsMGR-title3-container">
                        <h2 className="LocationMRvsMGR-title3">
                        {heading}
                        </h2>
                    </div>

                    {renderComparisonTable()}

                    {/* <div className="LocationMRvsMGR-table-wrapper" ref={tableRef}>
                        <table className="LocationMRvsMGR-table">
                        <thead className="text-white">
                            <tr>
                            <th>S.No</th>
                            <th>Chemist</th>
                            <th>Days</th>
                            <th>Frequency</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((item, index) => (
                            <tr key={item.stockist_code || index}>
                                <td>{index + 1}</td>
                                <td>{item.chemist_name}</td>
                                <td>{item.visit_dates || 'No visits'}</td>
                                <td>{item.frequency}</td>
                            </tr>
                            ))}
                        </tbody>
                        </table>
                    </div> */}
                    </div>

                    {/* ✅ Buttons outside the table container */}
                    <div className="LocationMRvsMGR-button-group">
                    <CustomButton
                        className="LocationMRvsMGR-print-btn"
                        onClick={handlePrint}
                        buttonType="primary"
                        variant="print"
                    >
                        Print
                    </CustomButton>
                    <CustomButton
                        className="LocationMRvsMGR-export-btn"
                        onClick={handleExport}
                        buttonType="success"
                        variant="export"
                    >
                        Export to Excel
                    </CustomButton>
                    </div>
                </>
                )}


    </div>
  );
};

export default LocationMRvsMGR;
